/**
 * 260914 유저 지시: 로그인 화면에 '최근 로그인' 말풍선 — 마지막으로 성공한 로그인 수단을 기기에 기억한다.
 *
 * 기록 지점은 store `user/signIn` 액션 성공 1곳이다. 이메일 로그인·소셜 4경로(signIn/NaverCallback/
 * KakaoCallback/NativeCall)·가입 직후 자동 로그인이 전부 그 액션으로 수렴하므로 한 줄로 전 경로를 덮는다.
 * 값은 JOIN_TYPE 키(GENERAL/KAKAO/NAVER/GOOGLE/APPLE). 로그아웃 reset(store/index.js)은 PROJECT_NAME
 * 키만 지우므로 이 키는 살아남는다 — 로그아웃 뒤에 보여주는 게 목적이라 의도한 동작이다.
 * 계정 식별 정보는 담지 않는다(수단만).
 */
const KEY = 'jump.lastLoginType';

export const markRecentLogin = joinType => {
  if (!joinType) return;
  try {
    localStorage.setItem(KEY, joinType);
  } catch (_) { /* private mode 등 */ }
};

export const getRecentLogin = () => {
  try {
    return localStorage.getItem(KEY) || '';
  } catch (_) {
    return '';
  }
};
